(function () {
    angular
        .module("dashboard")
        .controller("OrderUpToggleStatusModalController", [
            "$scope",
            "$uibModalInstance",
            "OrderUpOrdersService",
            "PermissionService",
            "channelIsOnline",
            "callback",
            OrderUpToggleStatusModalController ]);

    function OrderUpToggleStatusModalController(
        $scope,
        $uibModalInstance,
        orderUpOrderService,
        permissionService,
        channelIsOnline,
        callback
    ) {
        $scope.channelIsOnline = channelIsOnline;
        $scope.storeName = permissionService.userContext.StoreName;
        $scope.cancel = function () {
            $uibModalInstance.close();
        };
        $scope.toggle = function () {
            $scope.isLoading = true;
            return orderUpOrderService.toggleStoreChannelStatus(
                permissionService.userContext.StoreId,
                !$scope.channelIsOnline,
            ).then((result) => {
                callback(result);
                $scope.isLoading = false;
                $uibModalInstance.close();
            });
        }
        $scope.rejectReason = "Too Busy";
    }
})();
